<template>
  <validation-observer v-slot="{ invalid }">
    <form @submit.prevent="handleSubmit">
      <validation-provider name="Supplier" v-slot="context" rules="required">
        <multi-select
          v-model="supplier"
          placeholder="Pick a supplier"
          track-by="invoice_legal_name"
          label="invoice_legal_name"
          :options="suppliers"
          @search-change="findSupplier"
        />

        <small v-if="context.errors.length" v-bind="context.ariaMsg" class="text-danger form-text">
          {{ context.errors[0] }}
        </small>
      </validation-provider>

      <template v-if="supplier">
        <hr />

        <validation-provider name="Supplier" v-slot="context" rules="required">
          <multi-select
            v-model="variation"
            placeholder="Pick a variation"
            track-by="variation_name"
            label="variation_name"
            :options="supplier.variations"
            :custom-label="nameWithLang"
          />

          <small v-if="context.errors.length" v-bind="context.ariaMsg" class="text-danger form-text">
            {{ context.errors[0] }}
          </small>
        </validation-provider>
        <hr />

        <b-row>
          <b-col>
            <validation-provider name="Start Time" v-slot="context" rules="required">
              <b-form-group label="Start Time">
                <b-form-datepicker
                  locale="nb-NO"
                  :start-weekday="1"
                  v-model="start_time"
                  :state="getValidationState(context)"
                  v-bind="context.ariaInput"
                />

                <b-form-invalid-feedback v-bind="context.ariaMsg">
                  {{ context.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col>
            <validation-provider name="End Time" v-slot="context" rules="required">
              <b-form-group label="End Time">
                <b-form-datepicker
                  locale="nb-NO"
                  :start-weekday="1"
                  v-model="end_time"
                  :state="getValidationState(context)"
                  v-bind="context.ariaInput"
                />

                <b-form-invalid-feedback v-bind="context.ariaMsg">
                  {{ context.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <validation-provider name="Valid For" v-slot="context" rules="required">
          <b-form-group label="Valid For (Participants)">
            <b-form-input
              v-model="valid_for"
              placeholder="e.g 1"
              :state="getValidationState(context)"
              v-bind="context.ariaInput"
            />

            <b-form-invalid-feedback v-bind="context.ariaMsg">
              {{ context.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider name="Alert When" v-slot="context" rules="required">
          <b-form-group label="Alert When (Remaining Codes)">
            <b-form-input
              v-model="alert_when"
              placeholder="e.g 1"
              :state="getValidationState(context)"
              v-bind="context.ariaInput"
            />

            <b-form-invalid-feedback v-bind="context.ariaMsg">
              {{ context.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider name="Codes" v-slot="context" rules="required">
          <b-form-group label="Codes">
            <b-textarea
              v-model="codes"
              placeholder="e.g A 1212121212"
              :state="getValidationState(context)"
              v-bind="context.ariaInput"
            />

            <b-form-invalid-feedback v-bind="context.ariaMsg">
              {{ context.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-row align-h="end">
          <b-col cols="auto">
            <b-button type="submit" variant="primary" :disabled="$cannot('supplier.manage') || invalid">
              Add
            </b-button>
          </b-col>
        </b-row>
      </template>
    </form>
  </validation-observer>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'
import MultiSelect from 'vue-multiselect'
import { getValidationState } from '../page-helpers'
import { products, suppliers } from '@youwish1/api-package'

export default {
  name: 'CSVCodesBatchForm',
  inject: ['$cannot'],
  components: { MultiSelect },
  beforeMount() {
    this.findSupplier('')
  },
  data() {
    return {
      variation: null,
      variations: [],
      suppliers: [],
      supplier: null,

      codes: '',
      alert_when: 1,
      start_time: '',
      end_time: '',
      valid_for: 1,
    }
  },
  methods: {
    getValidationState,
    async findSupplier(text) {
      const response = await suppliers.all({
        filter: {
          booking_name: text,
          book_csv_activated: true
        },
      })

      this.suppliers = response.data()
    },
    nameWithLang({ variation_name, place }) {
      return `${variation_name}, ${place.city.name}`
    },
    async handleSubmit() {
      await products.variations.batches.create(this.variation.id, {
        codes: this.codes,
        alert_when: this.alert_when,
        start_time: this.start_time,
        end_time: this.end_time,
        valid_for: this.valid_for,
      })

      this.$bvToast.toast(`Codes for supplier uploaded.`, {
        title: 'Code batch uploaded',
        variant: 'primary',
      })

      this.$emit('close')
    },
  },
}
</script>
